export const slugify = (text: string): string => {
    return text
      .toString()
      .toLowerCase()
      .replace(/[^\w\s-]/g, "") // remove punctuation except -/_
      .trim()
      .replace(/\s+/g, "-"); // spaces to dashes
  }
  